import {FormGroup} from '@angular/forms';
import {MxButtonClickHandlerFn, MxButtonModel} from '../../mx-button/components/mx-button.model';

export type MxFilterButtonHiddenFn = () => boolean;

export type MxFilterButtonClickHandlerFn = (filterForm: FormGroup) => void;
export type FilterButtonDisableFn = () => boolean;

export class MxFilterButtonModel {

    public permission?: string = 'all';
    public hidden?: MxFilterButtonHiddenFn | boolean = false;
    public label?: string;
    public name?: string;
    public type?: string;
    public className?: string;
    public color?: string;
    public icon?: string;
    public tooltip?: string;
    public disabled?: FilterButtonDisableFn | boolean = false;
    public clickHandler?: MxFilterButtonClickHandlerFn;
}

export class MxFilterButtonsConfig {
    private _map: Map<string, MxFilterButtonModel>;

    public static createButtonInput(filterButtonModel: MxFilterButtonModel, clickHandler: MxButtonClickHandlerFn): MxButtonModel {
        return {
            tooltip: filterButtonModel.tooltip,
            permission: filterButtonModel.permission,
            name: filterButtonModel.name,
            label: filterButtonModel.label,
            icon: filterButtonModel.icon,
            color: filterButtonModel.color,
            className: filterButtonModel.className,
            clickHandler: clickHandler,
            hidden: filterButtonModel.hidden,
            disabled: filterButtonModel.disabled
        };
    }

    constructor(entries?: ReadonlyArray<[string, MxFilterButtonModel]>) {
        this._map = new Map<string, MxFilterButtonModel>(entries);
    }

    get = (key: string) => this._map.get(key);
    set = (key: string, value: MxFilterButtonModel) => this._map.set(key, value);
    getArray = () => {return Array.from(this._map.values()); };
    forEach = (callback: (value: MxFilterButtonModel, key: string, map: Map<string, MxFilterButtonModel>) => void, thisArg?: any) =>
        this._map.forEach(callback, thisArg)
}
